<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "performanceRule",
      key: "id",
      url: {
        get: "/admin/system/performanceRule",
        // add: "/admin/system/performanceRule/add",
        // edit: "/admin/system/performanceRule/edit",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "工程师",
          name: "userId",
          value: null,
          type: "select",
          width: "400px",
          dropList: [],
          rules: [{ required: true, trigger: "change", type: "number" }],
        },
        {
          label: "基础绩效工资",
          name: "performanceSalary",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
          width: "400px",
        },
        {
          label: "工单数量",
          name: "monthlyTargetCount",
          value: "",
          type: "input",
          width: "400px",
          disabled: true,
          rules: [{ required: true, trigger: "blur" }],
        },
      ],
      forms: {},
      customerId: null,
      performanceSalary: null,
    };
  },
  created() {
    let customerId = this.$route.query.customerId;
    let monthlyTargetCount = this.$route.query.monthlyTargetCount;
    this.customerId = customerId;
    this.forms.monthlyTargetCount = monthlyTargetCount + "";
    this.loadfacilityNoData(customerId);
  },
  methods: {
    loadfacilityNoData(customerId) {
      // 通过pk查询字典数据
      let q = {
        customerId,
      };
      $utils.api
        .load("/admin/system/maiUser/insCustomerList", q)
        .then((res) => {
          if (res) {
            let ll = res.data;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.userId;
              xx.name = element.nickName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.items.length; index++) {
              const element = this.items[index];
              console.log(element);

              if (element && element.name == "userId") {
                // this.items[index]['dropList'] = dropList
                console.log(dropList, 11111111111);

                this.items[index]["dropList"] = dropList;
              }
            }
          }
        });
    },

    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/performanceRule/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          this.forms.monthlyTargetCount = res.data.monthlyTargetCount + "";
          this.forms.performanceSalary = res.data.performanceSalary + "";
          console.log(this.forms, 22222);
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      q.customerId = this.customerId;
      q.ruleType = 2;
      q.status = 1;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              this.action == "edit"
                ? "/admin/system/performanceRule/edit"
                : `/admin/system/performanceRule/add`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
  },
};
</script>
